import { useMutation } from "react-query";
import { createMedication } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useCreateMedication = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createMedication(clientId, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Medication added successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error || "Failed to add medication";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    createMedicationMutation: mutate,
    isCreateMedicationLoading: isLoading,
    ...rest,
  };
};

export default useCreateMedication;
